/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { _$, Button, Drawer, Pagination, Table, TableColumn, Tag } from '@king-design/react'
import { TriggerRecordItemProp } from '../container'
import { formatDate } from 'src/utils'
import { UserInfo } from 'src/components'
import { initPage, PageProps } from 'src/utils/interface'
import { useAsync } from 'react-use'
import { getTriggerLogList } from 'src/api/ApiEventOpsTrigger'

interface OptLogDrawerProps {
  className?: string
  visible: boolean
  record: TriggerRecordItemProp
  onClose: () => void
}

const OptLogDrawer: React.FC<OptLogDrawerProps> = ({ className, visible, record, onClose }) => {
  const [page, setPage] = useState<PageProps>(initPage)
  const { value: logList } = useAsync(async () => {
    if (visible && record?.Sign) {
      const result = await getTriggerLogList({
        Sign: record?.Sign,
        Limit: page.PageSize,
        Offset: (page.Page - 1) * page.PageSize
      })
      return result
    } else {
      setPage(initPage)
      return {
        Info: [],
        Total: 0
      }
    }
  }, [visible, page])
  return (
    <div id="log-page" className={className}>
      <Drawer
        value={visible}
        width={800}
        title={_$('操作日志')}
        container={() => document.getElementById('log-page')}
        onChangeValue={show => {
          if (!show) {
            onClose()
          }
        }}
        slotFooter={
          <Button
            onClick={() => {
              onClose()
            }}
          >
            {_$("关闭")}
          </Button>
        }
      >
        <>
          <Table
            data={logList?.Info || []}
            animation={false}
            rowKey={record => record.ID}
            checkType="none"
          >
            <TableColumn key="ID" title={_$('序号')} width="50" />
            <TableColumn
              key="Operator"
              title={_$('操作人')}
              width="120"
              slotTemplate={([{ Operator }]) => {
                return <UserInfo name={Operator} />
              }}
            />
            <TableColumn
              key="Type"
              title={_$('操作类型')}
              width="80"
              slotTemplate={([{ Type }]) => {
                const map = {
                  enable: (
                    <Tag type="primary" border="solid">
                      {_$("启用中")}
                    </Tag>
                  ),
                  disable: (
                    <Tag type="danger" border="solid">
                      {_$("已停用")}
                    </Tag>
                  )
                }
                return map[Type]
              }}
            />
            <TableColumn
              key="CreatedAt"
              title={_$('时间')}
              width="180"
              slotTemplate={([{ CreatedAt }]) => {
                return formatDate(CreatedAt)
              }}
            />
            <TableColumn key="Remark" title={_$('备注')} />
          </Table>
          <Pagination
            value={page.Page}
            limit={page.PageSize}
            size="small"
            total={logList?.Total || 0}
            onChangeValue={value => {
              setPage({
                ...page,
                Page: value
              })
            }}
            onChangeLimit={limit => {
              setPage({
                ...page,
                PageSize: limit
              })
            }}
          />
        </>
      </Drawer>
    </div>
  )
}

export default styled(OptLogDrawer)``
